import React from "react";
import { useTranslation } from "react-i18next";

import MessageBox from "../../../../../components/MessageBox";
import ModalContainer from "../../../../../components/ModalContainer";
import Button from "../../../../../components/Button";

export const defaulGenerateReportMessages = {
  show: false,
  label: null,
};

const GenerateReport = (props) => {
  const { t } = useTranslation();
  const {
    isGenerateReportModal,
    setGenerateReportModal,
    generateReportMessages,
    setGenerateReportMessages,
    generateReport
  } = props;

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={isGenerateReportModal}
      closeModal={() => setGenerateReportModal(false)}
    >
      <div className='header'>
        <div className='title'>{t('8e75603fd5')}</div>
      </div>
      <div className='body'>
        <MessageBox
          show={generateReportMessages.show}
          label={generateReportMessages.label}
          variant='danger'
          onClose={() => setGenerateReportMessages({ ...defaulGenerateReportMessages, show: false })}
        />
        <p>{t('104fd97426')}</p>
        <p>{t('c3fc8726b7')}</p>
      </div>
      <div className='footer'>
        <Button
          label={t('ea4788705e')}
          className='btn-cancel'
          onClick={() => setGenerateReportModal(false)}
        />
        <Button
          label={t('93cba07454')}
          className='btn-submit'
          onClick={() => generateReport()}
        />
      </div>
    </ModalContainer >
  )
}

export default React.memo(GenerateReport);